import React, { useEffect, useState } from 'react';
import { EmptyState } from '@/components/custom/empty-state';
import { StudyGuideDiagnosticDataGrid } from './study-guide-diagnostic-data-grid';
import { useClient } from 'jsonapi-react';
import { GuideAboutCard, GuideAboutCardBody, GuideAboutCardHeader, GuideAboutCardTitle } from '@/components/custom/guide';

export function StudyGuideDiagnostic() {
  const [diagnosticData, setDiagnosticData] = useState([]);
  const client = useClient();

  const getDiagnosticData = async () => {
    const response = await client.fetch('study_plan_reports/question_books_list');
    return response.data;
  };

  useEffect(() => {
    getDiagnosticData().then(data => {
      if (data.question_books_list) setDiagnosticData(data.question_books_list);
    });
  }, []);

  const hasDiagnosticData = diagnosticData.length > 0;

  return (
    <GuideAboutCard>
      <GuideAboutCardHeader>
        <GuideAboutCardTitle>Rendimento em prova diagnóstica</GuideAboutCardTitle>
      </GuideAboutCardHeader>

      {!hasDiagnosticData && (
        <GuideAboutCardBody isEmpty>
          <EmptyState
            type="data"
            title="Você ainda não respondeu uma prova diagnóstica"
            text=" "
            variant="plain"
            className="m-auto"
          />
        </GuideAboutCardBody>
      )}

      {hasDiagnosticData && (
        <GuideAboutCardBody>
          <StudyGuideDiagnosticDataGrid data={diagnosticData} />
        </GuideAboutCardBody>
      )}
    </GuideAboutCard>
  );
}
